<template>
    <div class="container hearing-test">
      <div class="row">
        <div class="col-sm-12">
          <div class="title-wrapper">
            <h2 class="title">Hearing Test</h2>
          </div>
          <p class="subtitle">press the button every time you hear a tone</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="rect-wrapper mb-5">
            <div class="row d-flex justify-content-center align-items-center">
              <div
                class="col-sm-12 col-md-12 col-lg-5 d-flex justify-content-center align-items-center"
              >
                <div class="rect-left">
                  <div
                    v-for="dash in 7"
                    :class="{active: i + 2 > dash && !rightEar, testing: dash === i + 1 && !rightEar && running}"
                    class="rect"
                  ></div>
                  <div :class="{active: !rightEar}" class="left-side"><span>L</span></div>
                </div>
              </div>
              <div class="vertical-divider"></div>
              <div
                class="col-sm-12 col-md-12 col-lg-5 d-flex justify-content-center align-items-center"
              >
                <div class="rect-right">
                  <div :class="{active: rightEar}" class="right-side"><span>R</span></div>
                  <div
                    v-for="dash in 7"
                    :class="{active: i + 2> dash && rightEar, testing: dash === i + 1 && rightEar && running}"
                    class="rect"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="image-wrapper mb-5">
            <img v-show="!rightEar" src="/img/speakersL.png" alt="speakers-left" />
            <img v-show="rightEar" src="/img/speakersR.png" alt="speakers-left" />
            <div @click="onTap()" class="button-wrapper">
              <div class="button-top"></div>
              <div class="button-middle"><span>{{ complete ? 'Done' : (running ? 'Press' : 'Start')}}</span></div>
              <div class="button-bottom"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!complete" class="row">
        <div class="col-sm-12">
          <div class="description-wrapper">
            <p>
              you are now listening a
              <span :class="rightEar ? 'right' : 'left'" class="position">{{rightEar ? 'right' : 'left'}}</span>
              ear signal
            </p>
          </div>
        </div>
      </div>
      <div v-show="complete" class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
          <div class="button-wrapper">
            <router-link to="/login" class="button-main">View results</router-link>
            <a @click.prevent="restart()" href="" class="button-minor">Restart hearing test</a>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import testHeadset from './test-headset'

  export default {
    extends: testHeadset
  }
</script>
